import React from 'react';
import { FieldArrayRenderProps } from 'formik';
import { Box, Card, IconButton, Popover, PopoverContent, PopoverTrigger, Text } from 'pounceV2';
import { useTheme } from '@mui/material';

type AddMenuButtonProps = {
  push: FieldArrayRenderProps['push'];
  newItem?: Record<string, any>;
  newGroup?: Record<string, any>;
  unitLabel?: string;
  allowGroups?: boolean;
  disabled?: boolean;
};
const AddMenuButtonV3: React.FC<AddMenuButtonProps> = ({
  push,
  newItem = {},
  newGroup = [],
  unitLabel = 'Condition',
  allowGroups = false,
  disabled = false,
}) => {
  const {
    palette: { componentTokens },
    shadows,
  } = useTheme();

  return allowGroups ? (
    <Popover>
      {({ close: closePopover }) => (
        <>
          <Box>
            <PopoverTrigger
              as={IconButton}
              disabled={disabled}
              variant="outline"
              size="small"
              icon="add"
              aria-label="Add"
              data-tid="add-compoundinputfieldarray-button"
            />
          </Box>
          <PopoverContent>
            <Card
              as="ul"
              boxShadow={shadows[23]}
              minWidth={100}
              my={1}
              border={`1px solid ${componentTokens.selectMenuItems.color.item.stroke.container.resting}`}
              backgroundColor={componentTokens.selectMenuItems.color.item.background.containerBase}
            >
              <Box
                px={1.5}
                py={3}
                as="li"
                cursor="pointer"
                _hover={{
                  backgroundColor: componentTokens.selectMenuItems.color.item.background.row.hover,
                }}
                data-tid="add-compoundinputfieldarray-element"
                onClick={() => {
                  push(newItem);
                  closePopover();
                }}
              >
                <Text>Add {unitLabel}</Text>
              </Box>
              <Box
                px={1.5}
                py={3}
                as="li"
                cursor="pointer"
                _hover={{
                  backgroundColor: componentTokens.selectMenuItems.color.item.background.row.hover,
                }}
                data-tid="add-compoundinputfieldarray-element-group"
                onClick={() => {
                  push(newGroup);
                  closePopover();
                }}
              >
                <Text>Add {unitLabel} Group</Text>
              </Box>
            </Card>
          </PopoverContent>
        </>
      )}
    </Popover>
  ) : (
    <IconButton
      variant="outline"
      size="small"
      icon="add"
      aria-label="Add"
      data-tid="add-compoundinputfieldarray-button"
      disabled={disabled}
      onClick={() => {
        push(newItem);
      }}
    />
  );
};

export default React.memo(AddMenuButtonV3);
